import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20background%20with%20soft%20film%20grain%20texture%2C%20warm%20golden%20spotlight%20glow%20in%20center%2C%20elegant%20theater%20atmosphere%2C%20dramatic%20mood%20lighting%2C%20rich%20warm%20tones&width=1800&height=600&seq=cta-bg-home&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/80 to-foreground-950/90"></div>
      <div className="relative z-10 max-w-3xl mx-auto text-center px-4 md:px-6">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          准备好开始你的<strong className="text-accent-400">观影之旅</strong>了吗？
        </h2>
        <p className="text-sm md:text-base text-foreground-300 mb-8 max-w-lg mx-auto leading-relaxed">
          海量高清影视资源，全程免费无广告。现在就加入红桃影视，享受极致观影体验！
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/movie"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 px-8 py-3 rounded-full font-semibold text-sm transition-all hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-play-circle-line mr-2"></i>
            开始免费观影
          </Link>
          <Link
            to="/about"
            className="bg-white/10 hover:bg-white/20 backdrop-blur-sm text-background-50 px-8 py-3 rounded-full font-medium text-sm transition-all whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}